export function delayedWindowURLChange(URL, timeOut = 3000) {
  setTimeout(function () {
    window.location = URL;
  }, timeOut);
}
